<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Wysyłka zamówień</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Wysyłka zamówień</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Wysyłka zamówień</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label for="username" class="control-label col-sm-2">
                  Numer zamówienia
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="orderId"
                    name="username"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Numer zamówienia"
                    required="required"
                    @input="scheduleAutoSend"
                    @keyup.enter="send"
                  />
                  <div v-if="errorsAdminData?.data" class="has-error">
                    <span class="help-block">
                      {{ errorsAdminData.data.detail }}
                    </span>
                  </div>
                  <div
                    v-if="errorsAdminData?.data?.nonFieldErrors"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.nonFieldErrors[0] }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-4 col-sm-offset-2">
                  <button
                    v-if="canSendOrder"
                    @click="send"
                    class="btn btn-primary"
                  >
                    Wyślij
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import router from "../../router/router";
import { hasPermission } from "../../permissions";
import { orderPermissionsConst } from "../../constants/orderConstants";

export default {
  name: "OrderSend",
  mixins: [],
  components: {},
  props: {},

  setup() {
    const orderId = ref();
    const errorsAdminData = ref();
    const showErrors = ref(false);
    const isSending = ref(false);
    const lastSentOrderId = ref("");
    const autoSendTimeout = ref(null);
    const store = useStore();
    const sendOrderData = computed(() => store.getters.getSendOrderData);

    const canSendOrder = computed(() =>
      hasPermission(orderPermissionsConst.send)
    );

    const send = () => {
      if (!canSendOrder.value) {
        return;
      }

      showErrors.value = true;
      const normalizedOrderId = String(orderId.value || "").trim();
      if (!normalizedOrderId || isSending.value) {
        return;
      }
      if (lastSentOrderId.value === normalizedOrderId) {
        return;
      }
      errorsAdminData.value = undefined;
      isSending.value = true;
      lastSentOrderId.value = normalizedOrderId;
      store.dispatch("sendOrder", normalizedOrderId);
    };

    const scheduleAutoSend = () => {
      const normalizedOrderId = String(orderId.value || "").trim();
      if (!normalizedOrderId) {
        return;
      }
      if (autoSendTimeout.value) {
        clearTimeout(autoSendTimeout.value);
      }
      autoSendTimeout.value = setTimeout(() => {
        send();
      }, 1200);
    };

    watch(
      () => sendOrderData.value,
      function (newValue) {
        isSending.value = false;
        if (newValue.status === 200) {
          router.push({
            name: "OrderPacking",
            path: "/order/send/",
            params: { pk: orderId.value },
          });
        } else {
          var msg = [];
          for (const [key, value] of Object.entries(newValue.data)) {
            msg.push(key + ": " + value);
          }

          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
          lastSentOrderId.value = "";
        }
      }
    );

    return {
      send,
      canSendOrder,
      scheduleAutoSend,
      errorsAdminData,
      showErrors,
      orderId,
    };
  },
  computed: {},
};
</script>
